<script setup>
	import { ref, onMounted } from 'vue'
	import { generateNumericID } from '@/composables/strings'

	const props = defineProps({
		form: Object,
		name: {
			type: String
		}
	})

	const testID = ref(null)
	onMounted(() => testID.value = generateNumericID(4))

	const returnValue = ( value ) => {
		const isArray = Object.prototype.toString.call(value) == '[object Array]'
		if(isArray) {
			let array = []
			value.forEach((eachValue) => array.push(eachValue))
			return array
		} else {
			return value
		}
	}
</script>

<template>
	<button class="trigger-test btn btn-primary cg-row-content gap-2" type="button" data-bs-toggle="offcanvas" :data-bs-target="`#form-test-${testID}`">
		<FontAwesomeIcon icon="fa-solid fa-code" /> {{ name ?? 'Open Test Form' }}
	</button>

	<div class="offcanvas offcanvas-end bg-dark" data-bs-scroll="true" data-bs-backdrop="false" :id="`form-test-${testID}`">
		<div class="offcanvas-header">
			<h5 id="offcanvasRightLabel" class="cg-row-content gap-2"><FontAwesomeIcon icon="fa-solid fa-bars" /> {{ name ?? 'Open Test Form' }}</h5>
			<button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
		</div>
		<div class="offcanvas-body">
			<template v-if="typeof form == 'object' || typeof form == 'array'">
				<div class="start-form">form {{ typeof form }}: {</div>
					<template v-for="(value, key, index) in form" :key="index">
						<div class="items">
							<div :class="{ 'has-value': value }" class="item"><strong>{{ key }}:</strong> <pre>{{ returnValue(value) ? returnValue(value) : 'null' }}</pre></div>
							<div class="type"><span>{{typeof value}}</span></div>
						</div>
					</template>
				<div class="end-form">}</div>
			</template>
			<template v-else>
				<div class="items">
					<div :class="{ 'has-value': typeof form }" class="item"><pre>{{ form }}</pre></div>
					<div class="type"><span>{{ typeof form }}</span></div>
				</div>
			</template>

		</div>
	</div>
</template>

<style lang="scss" scoped>

	.offcanvas {
		z-index: 1022;
	}
	.start-form {
		margin-bottom: 15px;
	}
	.end-form {
		margin-top: 15px;
	}
	.items {
		display: grid;
		grid-template-columns: 50% 50%;

		.item {
			padding-top: 15px;
			padding-left: 15px;
			border-bottom: 1px solid var(--bs-secondary);
			background: rgba(209, 154, 102, .2);

			&.has-value {
				background: rgba(72, 136, 166, .2);
			}

			&:last-of-type {
				margin-bottom: 30px;
			}
		}

		.type {
			padding-top: 25px;
			padding-right: 15px;
			text-align: right;
			border-bottom: 1px solid var(--bs-secondary);
		}
	}

	.trigger-test {
		position: fixed;
		bottom: 50px;
		left: 20px;
		border-radius: var(--border-radius);
		z-index: 9999;
		transition: all .4s ease;

		&:hover {
			opacity: .6;
		}
	}

	#form-test {
		border-left: 1px solid var(--bs-primary);
	}
</style>